<template lang="pug">
v-container.pa-4
  v-toolbar(elevation=0)
    v-toolbar-title
      h3 Usuário - {{user.email}}
    v-spacer
    v-btn(@click='updateUserDialog = true' icon)
      v-icon mdi-pencil
  div.data-section
    h3 SOBRE
    div.my-2
      span.font-weight-bold Status
      v-checkbox(v-model='user.active' label='Ativo' disabled)
      v-btn(text @click='switchActivation()') {{user.person.suspended ? 'Desativar' : 'Ativar'}}
    div.my-2
      div
        span.font-weight-bold.font-weight-bold E-mail:&nbsp;
        span {{user.email}}
  div.data-section
    h3 PESSOA
    div.my-1
      div
        span.font-weight-bold Nome:&nbsp;
        span {{user.person.name}}
      div
        span.font-weight-bold CPF:&nbsp;
        span {{user.person.cpf}}
      div
        span.font-weight-bold Código:&nbsp;
        span {{user.person.code}}
      div
        span.font-weight-bold Status:
        v-checkbox(v-model='user.person.suspended' label='Suspenso' disabled)
    div
      h4 DETALHES
      div.my-1
        div
          span.font-weight-bold Telefone:&nbsp;
          span {{user.person.details.phone}}
        div
          span.font-weight-bold Empresa:&nbsp;
          span {{user.person.details.company}}
        div
          span.font-weight-bold Cargo:&nbsp;
          span {{user.person.details.role}}
        div
          span.font-weight-bold Imagem:&nbsp;
          v-img(:src='user.person.details.image_url' width='150px')
  v-dialog(v-model='updateUserDialog' max-width='')
    v-card
      v-card-title
        | Atualizar Usuário
        v-spacer
        v-btn(icon @click='updateUserDialog = false')
          v-icon mdi-close
      v-card-text
        v-form(ref='form')
          v-text-field(v-model='newCredentials.email' label='Novo e-mail')
          v-text-field(
            v-model='newCredentials.password'
            label='Nova senha'
            :type="show ? 'text' : 'password'"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append='show = !show'
          )
      v-card-actions
        v-btn(text @click='$refs.form.reset()') Limpar
        v-spacer
        v-btn(text @click='updateUserCredentials()') Salvar
  v-snackbar(v-model='snackbar')
    div Dados do usuário atualizados
    v-spacer
    v-btn(@click='snackbar = false' icon)
      v-icon mdi-close

</template>

<script>
import utils from '../utils/requests'

export default {
  data () {
    return {
      id: this.$route.params.id,
      user: {},
      updateUserDialog: false,
      newCredentials: {
        email: '',
        password: ''
      },
      snackbar: false,
      show: false
    }
  },
  mounted () {
    utils.postAPI('/users/get_user_details', { 'id': this.id }).then(res => {
      // console.log('result: ', res)
      this.user = res
      this.parseData()
    })
  },
  methods: {
    parseData () {
      console.log('about to treat')

      if (!this.user.person) {
        this.user.person = {}
      }

      for (const prop in this.user.person) {
        if (!this.user.person[prop]) {
          this.user.person[prop] = ''
        }
      }

      if (!this.user.person.details) {
        this.user.person.details = {}
      } else {
        for (const prop in this.user.person.details) {
          if (!this.user.person.details[prop]) {
            this.user.person.details[prop] = ''
          }
        }
      }

      console.log(this.user)
    },
    switchActivation () {
      utils.postAPI('/users/switch_user_activation', { id: this.id }).then(res => {
        window.location.reload()
      })
    },
    updateUserCredentials () {
      const data = {
        user_id: this.id,
        email: this.newCredentials.email,
        password: this.newCredentials.password
      }
      utils.postAPI('/users/update_user', data).then(res => {
        console.log(res)
        this.$refs.form.reset()
        this.updateUserDialog = false
        this.snackbar = true
        window.location.reload()
      })
    }
  }
}
</script>
